// @ts-nocheck
import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
  position: relative;

  span {
    font-size: 14px;
    font-weight: 700;
    color: #c53030;
  }

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }
`;

export const Label = styled.label`
  font-size: 1.063rem;
  font-weight: bold;
  color: ${({ disabled }) => disabled ? "var(--cinza-50)" : "var(--cinza-90)"};
  letter-spacing: 0.2px;

  @media screen and (max-width: 950px) {
    font-size: 15px;
    line-height: 24px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px;
  margin-right: 1.5rem;
  position: relative;
  background: var(--white);
  border: 1px solid var(--cinza-50);
  box-sizing: border-box;
  border-radius: 0.5rem;
  margin-top: 0.25rem;

  ${(props) => props.isErrored
    && css`
      border-color: #c53030;
    `}

  ${props => props.isFocused && css`
    color: var(--principal-40);
    border-color: var(--principal-40);
  `}

  ${props => props.isFilled && css`
    color: var(--principal-40);
  `}

  /* span {
    width: 3rem;
    height: 100%;
    display: flex;
    position: absolute;
    align-items: center;
    pointer-events: none;
    justify-content: center;
    left: 0;
    top: 0;
  } */

  svg {
    margin-right: 8px;
  }

  > button {
    border: 0;
    outline: none;
    background: transparent;

    > svg {
      margin: 0;
    }
  }

  input {
    flex: 1;
    background: transparent;
    font-size: var(--font-17);
    line-height: 1.75rem;
    width: 100%;
    border: none;
    outline: none;

    &:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px #ffffff inset;
      -webkit-text-fill-color: var(--cinza-90);
    }
  }

  input.MuiInputBase-input {
    padding: 1px 0;
  }

  &:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 950px) {
    input,
    input::placeholder {
      font-size: 17px;
      line-height: 28px;
    }

    span,
    span.resetPassword {
      font-size: 17px;
      line-height: 28px;
    }
  }
`;